import { DOCUMENTS_URLS } from 'constants/urls'

export const DOCUMENTS = DOCUMENTS_URLS.DOCUMENTS
export const UPLOAD_DOCUMENT = DOCUMENTS_URLS.UPLOAD_DOCUMENT
export const VIEW_DOCUMENT = DOCUMENTS_URLS.VIEW_DOCUMENT
export const SIGN_DOCUMENT = DOCUMENTS_URLS.SIGN_DOCUMENT
export const SURVEY = DOCUMENTS_URLS.SURVEY
export const CUSTOM_FORM = DOCUMENTS_URLS.CUSTOM_FORM
export const VIEW_SUBMITTED_CUSTOM_FORM = DOCUMENTS_URLS.VIEW_SUBMITTED_CUSTOM_FORM
